<ion-accordion-group [expand]="expand" [value]="value" (ionChange)="onAccordionGroupChanged($event)">
  @for (item of items; track item.id) {
    <ion-accordion [value]="item.id">
      <ion-item slot="header">
        <ion-label class="accordion-label">{{ item.label }}</ion-label>
      </ion-item>
      <div class="rtf accordion-content" color="dark" slot="content" [innerHTML]="item.content"></div>
    </ion-accordion>
  }
</ion-accordion-group>
